import { provideHttpClient } from '@angular/common/http'
import { ApplicationConfig, LOCALE_ID, importProvidersFrom } from '@angular/core'
import { LuxonDateAdapter } from '@angular/material-luxon-adapter'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'
import { provideAnimations } from '@angular/platform-browser/animations'
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router'
import { provideFuse } from '@fuse'
import { NgxsFormPluginModule } from '@ngxs/form-plugin'
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin'
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin'
import { NgxsModule } from '@ngxs/store'
import { appRoutes } from 'app/app.routes'
import { provideAuth } from 'app/core/auth/auth.provider'
import { provideIcons } from 'app/core/icons/icons.provider'
import { provideTranslation } from 'app/core/transloco/transloco.provider'
import { mockApiServices } from 'app/mock-api'
import { environment } from 'environments/environment'
import { AuthState } from './modules/auth/auth.state'
import { NgxsResetPluginModule } from 'ngxs-reset-plugin'
import { AppState } from './app.state'
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin'
import { MarkdownModule } from 'ngx-markdown'

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    provideAnimations(),
    provideHttpClient(),
    provideRouter(appRoutes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
    ),
    importProvidersFrom(MarkdownModule.forRoot()),
    importProvidersFrom(NgxsModule.forRoot([AuthState, AppState])),
    importProvidersFrom(NgxsLoggerPluginModule.forRoot({
      disabled: environment.production,
    })),
    importProvidersFrom(NgxsFormPluginModule.forRoot()),
    importProvidersFrom(NgxsStoragePluginModule.forRoot({
      key: ['auth', 'app']
    })),
    importProvidersFrom(NgxsResetPluginModule.forRoot()),
    importProvidersFrom(NgxsReduxDevtoolsPluginModule.forRoot()),
    // Material Date Adapter
    {
      provide: DateAdapter,
      useClass: LuxonDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'D',
        },
        display: {
          dateInput: 'DDD',
          monthYearLabel: 'LLL yyyy',
          dateA11yLabel: 'DD',
          monthYearA11yLabel: 'LLLL yyyy',
        },
      },
    },

    // Transloco Config
    provideTranslation(),

    // Fuse
    provideAuth(),
    provideIcons(),
    provideFuse({
      mockApi: {
        delay: 0,
        services: mockApiServices,
      },
      fuse: {
        layout: 'material',
        scheme: 'light',
        screens: {
          sm: '600px',
          md: '960px',
          lg: '1280px',
          xl: '1440px',
        },
        theme: 'theme-brand',
        themes: [
          {
            id: 'theme-default',
            name: 'Default',
          },
          {
            id: 'theme-brand',
            name: 'Brand',
          },
          {
            id: 'theme-teal',
            name: 'Teal',
          },
          {
            id: 'theme-rose',
            name: 'Rose',
          },
          {
            id: 'theme-purple',
            name: 'Purple',
          },
          {
            id: 'theme-amber',
            name: 'Amber',
          },
        ],
      },
    }),
  ],
}
